exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".image--66oJI {\n\tpadding-bottom: 5px;\n}\n", ""]);

// Exports
exports.locals = {
	"image": "image--66oJI"
};